module.exports = __webpack_public_path__ + "static/media/bomb.b68af747.mp3";